import React, { useEffect, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import Accordion from "react-bootstrap/Accordion";
import Connection from "./Connection";
import DataFilter from "./DataFilter";
// import ChannelMap from "./ChannelMap";
import ProductDataMapping from "./ProductDataMapping";
import ProductCatlogConfiguration from "./ProductCatlogConfiguration";
import CollectionCatlogConfiguration from "./CollectionCatlogConfiguration";
import CustomToast from "../common/CustomToast";
import Layout from "../../components/Layout";
import MarketConfiguration from "./MarketConfiguration";

function Configurations({changeTab}) {
    const [akeneoData, setAkeneoData] = useState(null);
    const [toastConfig, setToastConfig] = useState({ status: null, message: null });
    const [clickedButton, setClickedButton] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const connectionStatus = useSelector(state => state.data);
    const credsStatus = useSelector(state => state.saveCreds);
    const filterStatus = useSelector(state => state.dataFilters)
    const attributeStatus = useSelector(state => state.productMapping)
    const preExistingProductStatus = useSelector(state => state.preExistingProductCatalog)
    const preExistingCategoriesStatus = useSelector(state => state.preExistingCategoriesCatlog)
    const toggle = useSelector((state)=> state.config.data?.attributeMapping?.isPreExistingCatalog);

    // Memoized toast update function
    const updateToast = useCallback((config) => {
        if (config?.status && config?.message) {
            setToastConfig(config);
        }
    }, []);

    // Handle button clicks
    const handleButtonClick = useCallback((name) => {
        setClickedButton(name);
    }, []);

    // Effect to handle toast updates
    useEffect(() => {
        if (!clickedButton) return;

        // Simple mapping of button to status
        const statusMap = {
            testConnection: connectionStatus,
            saveCredentials: credsStatus,
            saveFilter: filterStatus,
            saveChannelMapping: filterStatus,
            saveattributeMapping: attributeStatus,
            successCopyClipboard: {status: "SUCCESS",message:"Copied Successfully"},
            failedCopyClipboard: {status: "FAILED",message:"Failed to Copy"}
        };

        const currentStatus = statusMap[clickedButton];

        if (currentStatus) {
            updateToast(currentStatus);
            
            if (currentStatus.status === 'SUCCESS' || currentStatus.status === 'FAILED' || currentStatus.status === 'error') {
                 setClickedButton(null);
            }

            if(clickedButton == "saveattributeMapping"){
                const timer = setTimeout(() => {
                setClickedButton(null);
                 }, 10000);
            }
        }
    }, [clickedButton, connectionStatus, credsStatus, filterStatus, attributeStatus, updateToast]);

    // Memoized Akeneo credentials handler
    const handleAkeneoCreds = useCallback((creds) => {
        setAkeneoData(creds);
    }, []);

    // Show loader when component mounts or re-renders
    useEffect(() => {
        setIsLoading(true);
        const timer = setTimeout(() => {
            setIsLoading(false);
        }, 1000);

        return () => clearTimeout(timer);
    }, []);

    return (
        <>
            {isLoading ? (
                <Layout />
            ) : (
                <Accordion defaultActiveKey="0">
                    {toastConfig.status && toastConfig.status !== "PIM loading" && (
                        <CustomToast
                            status={toastConfig.status}
                            body={toastConfig.message}
                            setStatus={(status) => setToastConfig(prev => ({ ...prev, status }))}
                        />
                    )}

                    <Connection passAkeneoCreds={handleAkeneoCreds} showToast={handleButtonClick} />
                    <DataFilter showToast={handleButtonClick} />
                    {toggle === "true" && <><CollectionCatlogConfiguration changeTab={changeTab}/><ProductCatlogConfiguration showToast={handleButtonClick} changeTab={changeTab}/> </>}
                    <MarketConfiguration showToast={handleButtonClick}/>
                    <ProductDataMapping showToast={handleButtonClick} />
                </Accordion>
            )}
        </>
    );
}

export default React.memo(Configurations);